module.exports = __webpack_public_path__ + "img/loader.9463db66.gif";